import { TScheduleMode } from "@components/schedule/common/scheduleMode";
import { TSchedule, TScheduleTemplate } from "@components/schedule/common/types";
import { Col, DatePicker, Row, Select } from "antd";
import dayjs from "dayjs";
import moment from "moment";

export type TScheduleType = { id: TScheduleMode; label: string, value: string };

type TProps = {
    schedule?: TSchedule | TScheduleTemplate;
    scheduleTypes: TScheduleType[];
    scheduleMode: TScheduleMode;
    onScheduleTypeChange: (option: TScheduleType | TScheduleType[]) => void;
    editing: boolean;
    onStartDateChange: (value: moment.Moment) => void;
};

const ScheduleTypeRow = ({
    schedule,
    scheduleTypes,
    scheduleMode,
    onScheduleTypeChange,
    editing,
    onStartDateChange,
}: TProps): JSX.Element => {
    return (
        <Row>
            <Col className="two-thirds-width">
                <Row>
                    <label className="required">Режим работы</label>
                </Row>
                <Row>
                    {editing ? (
                        <Select
                            className="set-font-size"
                            defaultValue={scheduleTypes[0].value}
                            onChange={(_, option) => onScheduleTypeChange(option)}
                            options={scheduleTypes}
                            style={{ width: '90%' }}
                            value={scheduleTypes.find(st => st.id === scheduleMode)?.value}
                        />
                    ) : (
                        <span className="readonly">
                            {scheduleTypes.find(st => st.id === scheduleMode)?.label}
                        </span>
                    )}
                </Row>
            </Col>
            {(schedule as TSchedule)?.start_schedule_at !== undefined 
                && scheduleMode === 'interval'
                && (
                <Col className="one-third-width">
                    <Row>
                        <label className="required">Начать график с</label>
                    </Row>
                    <Row>
                        {editing ? (
                            <DatePicker
                                allowClear={false}
                                className="wide-datepicker"
                                disabledDate={(date) => {
                                    return date && date < dayjs().endOf('day');
                                }}
                                format="DD-MM-YYYY"
                                inputReadOnly
                                onChange={(val) => onStartDateChange(val ? moment(val.toISOString()) : null)}
                                picker="date"
                                value={dayjs((schedule as TSchedule)?.start_schedule_at, "YYYY-MM-DD")}
                            />
                        ) : (
                            <span className="readonly">
                                {moment((schedule as TSchedule)?.start_schedule_at, "YYYY-MM-DD").format("DD.MM.YYYY")}
                            </span>
                        )}
                    </Row>
                </Col>
            )}
        </Row>
    );
};

export { ScheduleTypeRow };